import { createAsyncThunk } from "@reduxjs/toolkit";

import { getProduct } from "../../../api/reviews";
import { IReviewsProductID } from "../../../models/nominals";
import { IReviewsProduct } from "../../../models/reviews";

/**
 * Load a single product by its ID.
 *
 * Fetches the details of one specific product. Used when displaying reviews for
 * a single product page.
 *
 * @param {IReviewsProductID} productID - The product identifier to fetch
 *
 * @returns {Promise<IReviewsProduct>} Promise resolving to the product details
 *
 * @example
 * // Load a specific product
 * dispatch(loadProduct(12345));
 *
 * @sideEffects
 * - Updates `data.products` with a single-element array containing the product via extraReducers
 * - Sets `data.loadedInitialProducts` to true via extraReducers
 */
export const loadProduct = createAsyncThunk(
    "reviews/loadProduct",
    async (productID: IReviewsProductID): Promise<IReviewsProduct> => {
        const product = await getProduct(productID);
        return product;
    },
);
